(function () {
  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('msp-footer-map-modal--open');
    document.body.classList.remove('msp-footer-map-modal-active');
  }

  function openModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('msp-footer-map-modal--open');
    document.body.classList.add('msp-footer-map-modal-active');
    var closeBtn = modal.querySelector('.msp-footer-map-modal__close');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function initFooterMapModal() {
    var openBtn = document.getElementById('msp-footer-map-open');
    var modal = document.getElementById('msp-footer-map-modal');
    if (!openBtn || !modal) return;

    openBtn.onclick = function () {
      openModal(modal);
      return false;
    };

    var closers = modal.getElementsByTagName('button');
    var backdrop = modal.getElementsByClassName('msp-footer-map-modal__backdrop');
    var i;
    for (i = 0; i < backdrop.length; i++) {
      backdrop[i].onclick = function () {
        closeModal(modal);
        return false;
      };
    }
    for (i = 0; i < closers.length; i++) {
      if (closers[i].getAttribute('data-msp-footer-map-close') !== null) {
        closers[i].onclick = function () {
          closeModal(modal);
          return false;
        };
      }
    }

    document.onkeydown = function (e) {
      e = e || window.event;
      var key = e.key || e.keyCode;
      if (key === 'Escape' || key === 27) {
        if (modal.className.indexOf('msp-footer-map-modal--open') !== -1) {
          closeModal(modal);
        }
      }
    };
  }

  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', initFooterMapModal, false);
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') initFooterMapModal();
    });
  }
})();
